import React from 'react';
import SEO from './SEO';
import { KRZYZOWKI_HTML, KRZYZOWKI_STYL } from '../data/krzyzowkiTresc';
import { podlaczKrzyzowki } from '../data/krzyzowkiInterakcja';

/*
 * Krzyzowki sensoryczne - materialy do wykorzystania na zajeciach i w domu.
 *
 * Tresc arkusza (siatki, definicje, pola do wpisywania) pochodzi z generatora
 * krzyzowek i siedzi w ../data/krzyzowkiTresc.js jako gotowy HTML. Wstawiamy
 * go przez dangerouslySetInnerHTML, bo to statyczny, wlasny materialy - nie
 * ma tu tresci od uzytkownikow.
 *
 * Style arkusza uzywaja bardzo ogolnych klas (.lit, .def, .kl), dlatego kazda
 * regula jest ograniczona do kontenera .krz - inaczej rozjechalyby reszte
 * serwisu.
 *
 * Pola liter celowo nie sprawdzaja poprawnosci: to material do wypelnienia,
 * a nie test z wynikiem.
 */


/*
 * Zachowanie arkusza (przeskok kursora po literach, powiekszony opis na malym
 * ekranie) pochodzi z tego samego pliku, co wersja do druku: krzyzowki/
 * interakcja.js w repozytorium generatora, wystawiona jako modul krzyzowkiInterakcja.
 * dangerouslySetInnerHTML nie wykonuje <script>, wiec podpinamy go tutaj.
 */
function useInterakcja(ref) {
  React.useEffect(() => {
    const wezel = ref.current;
    if (!wezel) return undefined;
    return podlaczKrzyzowki(wezel);
  }, [ref]);
}

function Krzyzowki() {
  const kontener = React.useRef(null);
  useInterakcja(kontener);

  return (
    <>
      <SEO
        title="Krzyżówki sensoryczne - hasła z integracji sensorycznej"
        description="Sześć krzyżówek z hasłami z integracji sensorycznej, rozwoju i diagnozy dziecka. Można je rozwiązać w przeglądarce albo wydrukować."
        pathname="/krzyzowki/"
        type="website"
      />
      <div className="article-container">
        <h1>Krzyżówki sensoryczne</h1>
        <p>
          Sześć krzyżówek z hasłami z integracji sensorycznej, rozwoju dziecka i diagnozy.
          Litery można wpisywać bezpośrednio na stronie albo wydrukować arkusz i rozwiązać
          go na papierze. Litery z ponumerowanych pól układają się w hasło główne.
        </p>

        <style>{KRZYZOWKI_STYL}</style>
        {/* Warstwa siedzi wewnatrz .krz, bo wszystkie reguly arkusza sa
            prefiksowane tym kontenerem - poza nim nie dostalaby stylow. */}
        <div className="krz" ref={kontener}>
          <div dangerouslySetInnerHTML={{ __html: KRZYZOWKI_HTML }} />
        </div>
      </div>
    </>
  );
}

export default Krzyzowki;
